module.exports = __webpack_public_path__ + "img/home-fqa-moon-cat.79c6f036.svg";